import { runWithAdal } from '../src/components/react-adal/src/react-adal';
import { authContext } from './adalConfig';

const DO_NOT_LOGIN = true;

runWithAdal(authContext, () => {

    // eslint-disable-next-line
    require('./indexApp.js');

}, DO_NOT_LOGIN);


// WEBPACK FOOTER //
// ./src/index.js